import type { Metadata } from "next";
import fetchSongById from "./fetchSongById";
import getPageTitle from "./getSongPageTitle";
import slugify from "./slugify";
import type { SetList, Song } from "./types";

export function getSongViewRoute({
  song,
  setList,
}: { song: Song; setList?: SetList | null }): string {
  //console.debug("getSongViewRoute", songId, songName);
  const setListRoute = setList ? getSetListRoute({ setList }) : "";
  return song ? `${setListRoute}/song/${song.id}/${slugify(song.title)}` : "/";
}

export function getSongPlayRoute({
  song,
  setList,
}: { song: Song; setList?: SetList | null }): string {
  //console.debug("getSongPlayRoute", songId, songName);
  const setListRoute = setList ? getSetListRoute({ setList }) : "";
  return song ? `${setListRoute}/play/${song.id}/${slugify(song.title)}` : "/";
}

export function getSongEditorRoute({
  song,
  setList,
}: { song: Song; setList?: SetList | null }): string {
  const setListRoute = setList ? getSetListRoute({ setList }) : "";
  return song ? `${setListRoute}/edit/${song.id}` : "/";
}

export function getSetListRoute({ setList }: { setList: SetList }): string {
  return `/setlist/${setList.id}/${slugify(setList.title)}`;
}

export function getSongListRoute({
  setList,
}: { setList?: SetList | null }): string {
  return setList ? `/setlist/${setList.id}/${slugify(setList.title)}` : "/";
}

export async function generateSongMetadata(props: {
  params: Promise<{ songId: string }>;
}): Promise<Metadata> {
  const params = await props.params;
  const { songId } = params;
  let song: Song | undefined = undefined;
  try {
    song = await fetchSongById(songId);
  } catch (error) {
    console.error("Error fetching song for metadata", { error });
  }
  if (!song) return {};
  const title = getPageTitle({ song });
  return { title };
}
